export default __webpack_public_path__ + "static/media/classroom.834a4217.jpg";